export enum ChildManagerType {
  childManager = "childManager",
  dingTalkChildManager = "dingTalkChildManager",
}
